import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from "./locales/en.json";
import arTranslations from "./locales/ar.json";

const DEFAULT_LANGUAGE = "ar";

// Retrieve previously chosen language from sessionStorage if available
const savedLanguage = sessionStorage.getItem("selectedLanguage");

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    ar: {
      translation: arTranslations,
    },
  },
  lng: savedLanguage || DEFAULT_LANGUAGE, // Set language from storage or use default
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});

// Function to set language and store it in sessionStorage
export const changeLanguage = (language) => {
  i18n.changeLanguage(language);
  sessionStorage.setItem("selectedLanguage", language);
};

export default i18n;
